module.exports = __webpack_public_path__ + "img/plane_track_5.1f95d9d3.svg";